import { createAsyncThunk } from "@reduxjs/toolkit";
import ApiService from "../../utils/apiService";

export const login = createAsyncThunk("auth/login", async (credentials) => {
    const response = await ApiService.post("/login", credentials); // Assume it returns { token }
    return response;
  });